import { capitalize } from 'lodash'

import { AllowedTrandocs } from './ChargeWorkflow'
import { Payment } from '../../models/Payment'
import { NewChargeReceiptView } from './NewChargeReceiptView'

type Props = {
    trandoc?: AllowedTrandocs
}

export function NewChargeReceiptPage({ trandoc }: Props) {
    if (!trandoc) {
        return null
    }

    return (
        <NewChargeReceiptView
            payment={
                new Payment({
                    allow_surcharge: trandoc.allowSurcharge,
                    allow_sales_tax: trandoc.allowSalesTax,
                    charge_amount: trandoc.chargeAmount,
                    total: trandoc.total,
                    tax: trandoc.tax,
                    taxcode: trandoc.taxcode,
                    discount: trandoc.discount,
                    discount_type: trandoc.discountType,
                    gratuity_amount: trandoc.gratuity,
                    gratuity_type: trandoc.gratuityType,
                    lines: trandoc.lines,
                })
            }
            title={`${capitalize(trandoc?.recordType)} summary`}
            totalTitle={`${capitalize(trandoc?.recordType)} price`}
        />
    )
}
